import React from "react";
import "./TransactionsView.css";

export const TransactionsView = ({
  transactions,
  categoryVisibility,
  accountVisibility,
  toggleCategoryVisibility,
  toggleAccountVisibility,
}) => {
  // Get unique categories and accounts from transactions
  const uniqueCategories = [
    ...new Set(transactions.map((transaction) => transaction.category)),
  ];
  const uniqueAccounts = [
    ...new Set(transactions.map((transaction) => transaction.account)),
  ];

  return (
    <div className="transactions-view">
      <div className="visibility-section">
        <div className="category-section">
          <h3>Categories</h3>
          {uniqueCategories.map((category) => (
            <div
              key={category}
              className="category-accordion"
              onClick={() => toggleCategoryVisibility(category)}
              style={{
                cursor: "pointer",
                color: categoryVisibility[category] ? "gray" : "black",
              }}
            >
              <p>{category}</p>
            </div>
          ))}
        </div>

        <div className="account-section">
          <h3>Accounts</h3>
          {uniqueAccounts.map((account) => (
            <div
              key={account}
              className="account-accordion"
              onClick={() => toggleAccountVisibility(account)}
              style={{
                cursor: "pointer",
                color: accountVisibility[account] ? "gray" : "black",
              }}
            >
              <p>{account}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="transaction-table">
        <table>
          <thead>
            <tr>
              <th>Transaction Date</th>
              <th>Description</th>
              <th>Category</th>
              <th>Amount</th>
              <th>Account</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((transaction, index) => {
              const isHiddenByCategory =
                categoryVisibility[transaction.category];
              const isHiddenByAccount = accountVisibility[transaction.account];
              return (
                !isHiddenByCategory &&
                !isHiddenByAccount && (
                  <tr key={index}>
                    <td>{transaction.transactionDate}</td>
                    <td>{transaction.description}</td>
                    <td>{transaction.category}</td>
                    <td
                      className={
                        transaction.amount < 0 ? "negative" : "positive"
                      }
                    >
                      ${Math.abs(transaction.amount).toFixed(2)}
                    </td>
                    <td>{transaction.account}</td>
                  </tr>
                )
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
